/*
WARNING. DO NOT EDIT THIS FILE. THIS FILE IS
GENERATED BY package.json. INSTEAD, MODIFY THE
APPROPRIATE FILE IN /src/config
*/

// @flow
export default {
  api_root: "https://api.imagus.com.au"
};



// WEBPACK FOOTER //
// ./src/Properties.js